import { defineProperty as _defineProperty, taggedTemplateLiteral as _taggedTemplateLiteral, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { sizing } from '@statsbomb/kitbag-themes';
import { BUTTON_VARIANT, BUTTON_SIZE } from './Button.constants.js';

var _templateObject, _templateObject2;
var getPaletteForVariant = function getPaletteForVariant(_ref) {
  var theme = _ref.theme,
    _ref$$variant = _ref.$variant,
    $variant = _ref$$variant === void 0 ? BUTTON_VARIANT.PRIMARY : _ref$$variant;
  switch ($variant) {
    case BUTTON_VARIANT.ERROR:
      return theme.colours.messaging.error;
    case BUTTON_VARIANT.INFO:
      return theme.colours.messaging.info;
    case BUTTON_VARIANT.PRIMARY:
      return theme.colours["interface"];
    case BUTTON_VARIANT.SECONDARY:
      return theme.colours.canvas.secondary;
    case BUTTON_VARIANT.TERTIARY:
      return theme.colours.canvas.tertiary;
    case BUTTON_VARIANT.SUCCESS:
      return theme.colours.messaging.success;
    case BUTTON_VARIANT.WARNING:
      return theme.colours.messaging.warning;
    case BUTTON_VARIANT.UNKNOWN:
      return theme.colours.messaging.unknown;
    default:
      return {
        ink: theme.colours.ink.primary.main,
        main: 'transparent',
        strong: theme.colours.canvas.secondary.strong,
        weak: theme.colours.canvas.secondary.weak
      };
  }
};
var getColourStyles = function getColourStyles(props) {
  var variantPalette = getPaletteForVariant(props);
  var withOpacity = [BUTTON_VARIANT.SECONDARY, BUTTON_VARIANT.TERTIARY, BUTTON_VARIANT.GHOST].includes(props.$variant);
  return "\n    background: ".concat(variantPalette.main, ";\n    color: ").concat(withOpacity ? props.theme.applyOpacity(variantPalette.ink, 'secondary') : variantPalette.ink, ";\n    &:hover:not(:disabled) {\n        color: ").concat(variantPalette.ink, ";\n        background: ").concat(variantPalette.strong, ";\n    }\n    &:active:not(:disabled) {\n        color: ").concat(variantPalette.ink, ";\n        background: ").concat(variantPalette.weak, ";\n    }\n  ");
};
var getDisabled = function getDisabled(_ref2) {
  var disabled = _ref2.disabled,
    $isPending = _ref2.$isPending,
    theme = _ref2.theme;
  return {
    opacity: disabled && !$isPending ? theme.opacity.disabled : undefined
  };
};
var PADDING_INLINE_MAP = _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SMALL, sizing.small), BUTTON_SIZE.REGULAR, sizing.medium), BUTTON_SIZE.LARGE, sizing.large);
var BUTTON_REGULAR_VERTICAL_PADDING = '0.1875rem';
var PADDING_BLOCK_MAP = _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SMALL, sizing.xtiny), BUTTON_SIZE.REGULAR, BUTTON_REGULAR_VERTICAL_PADDING), BUTTON_SIZE.LARGE, sizing.regular);
var GAP_SIZE_MAP = _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SMALL, sizing.tiny), BUTTON_SIZE.REGULAR, sizing.small), BUTTON_SIZE.LARGE, sizing.regular);
var TYPOGRAPHY_SIZE_MAP = _defineProperty(_defineProperty(_defineProperty({}, BUTTON_SIZE.SMALL, 'headingSmall'), BUTTON_SIZE.LARGE, 'headingLarge'), BUTTON_SIZE.REGULAR, 'headingRegular');
var getSizes = function getSizes(_ref3) {
  var theme = _ref3.theme,
    _ref3$$size = _ref3.$size,
    $size = _ref3$$size === void 0 ? BUTTON_SIZE.REGULAR : _ref3$$size;
  return _objectSpread2(_objectSpread2({}, theme.typography[TYPOGRAPHY_SIZE_MAP[$size]]), {}, {
    gap: GAP_SIZE_MAP[$size],
    paddingBlock: PADDING_BLOCK_MAP[$size],
    paddingInline: PADDING_INLINE_MAP[$size]
  });
};
var InteractiveStyles = styled('button')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), getColourStyles, getDisabled);
var ButtonBase = styled(InteractiveStyles)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), getSizes);

export { ButtonBase, InteractiveStyles, getPaletteForVariant };
//# sourceMappingURL=ButtonBase.styles.js.map
